export default {
  getFormateDate: function (inputTime) {
    if (!inputTime) {
      return '错误数据'
    }
    var date = new Date(inputTime);
    var y = date.getFullYear();
    var m = date.getMonth() + 1;
    m = m < 10 ? ('0' + m) : m;
    var d = date.getDate();
    d = d < 10 ? ('0' + d) : d;
    var h = date.getHours();
    h = h < 10 ? ('0' + h) : h;
    var minute = date.getMinutes();
    var second = date.getSeconds();
    minute = minute < 10 ? ('0' + minute) : minute;
    second = second < 10 ? ('0' + second) : second;
    return y + '-' + m + '-' + d
  },
  //临时的湖南用的，商品，创建店铺的时间


}



// WEBPACK FOOTER //
// ./src/utils/utils.js